import { useSelector } from 'react-redux';
import { AppState } from 'src/models/AppState';
import { EnumsState } from './EnumsState';

export function useEnums(): EnumsState {
    return useSelector((state: AppState) => state.enums);
}
